// extracted by mini-css-extract-plugin
export default {"politicsPage":"Politics_politicsPage__eIfmv"};